// logoanimation.js
document.addEventListener("DOMContentLoaded", function() {
  const logo = document.querySelector('.logo-animation');
  setTimeout(() => {
    logo.classList.add('fade-out');
    setTimeout(() => {
      logo.style.display = 'none';
    }, 500); // フェードアウトの時間に合わせて0.5秒後に非表示にする
  }, 1000); // 1秒後にフェードアウトを開始
});